var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"block",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleClass($event)}}},[_c('i',{staticClass:"text-2xl",class:[_vm.isFaved ? 'fas fa-heart' : 'far fa-heart']})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-547b081a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/front/components/GeneralComponents/AddFav.vue
// module id = CPIR
// module chunks = 1